<template>
  <div class="text-start">
    <template v-if="trainingModuleContent">
      <!--trainingModuleContent title-->
      <v-row no-gutters class="mb-4">
        <v-col>
          <LocalisedContentEditable
            :values="trainingModuleContent.title"
            @update:values="updateTrainingModuleContentTitle"
            :placeholder="$t('course.courseDetails.contentNameHere')"
            :editable="isEditing"
            css-class="text-h6 font-weight-bold textLight--text"
            :hasError="trainingModuleContent.hasInvalidTitle"
            :selectedLocale="selectedLocale"
          />
        </v-col>
      </v-row>

      <!--trainingModuleContent duration-->
      <CourseNumberField
        :label="$t('course.courseDetails.contentDuration')"
        :value="trainingModuleContent.duration"
        @update:value="updateTrainingModuleContentDuration"
        :isEditing="isEditing"
        css-class="body-1 font-weight-medium textLight--text"
        class="mb-4"
      />

      <!--trainingModuleContent text-->
      <v-row no-gutters class="mb-4">
        <v-col>
          <LocalisedContentEditable
            :values="trainingModuleContent.text"
            @update:values="updateTrainingModuleContentText"
            element-type="RICH"
            :placeholder="$t('course.courseDetails.contentDescriptionHere')"
            :editable="isEditing"
            css-class="body-1 font-weight-light textLight--text"
            :selectedLocale="selectedLocale"
          />
        </v-col>
      </v-row>

      <!--trainingModuleContent delete button-->
      <v-row v-if="isEditing" justify="end">
        <v-col cols="auto">
          <v-btn
            small
            depressed
            color="#D75B5B"
            min-width="80"
            class="rounded-1 ms-2 white--text"
            :loading="isTrainingModuleContentDeleting"
            :disabled="isTrainingModuleContentSaving"
            @click="deleteTrainingModuleContent"
          >
            <v-icon small class="me-1">mdi-delete</v-icon>

            {{ $t("course.courseDetails.deleteModuleContent") }}
          </v-btn>
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import LocalisedContentEditable from "@/app/core-module/components/LocalisedContentEditable";
import CourseNumberField from "@/app/course-module/components/course-details/CourseNumberField";

export default {
  name: "CourseContentText",
  components: { CourseNumberField, LocalisedContentEditable },
  props: {
    training: {
      type: Object,
      required: true,
    },
    selectedTrainingModuleContent: {
      type: Object,
      required: true,
    },
    isEditing: {
      type: Boolean,
      required: true,
    },
    selectedLocale: {
      type: String,
      default: "en",
    },
  },
  data() {
    return {
      isTrainingModuleContentSaving: false,
      isTrainingModuleContentDeleting: false,
    };
  },
  computed: {
    trainingModuleContent() {
      return this.training.trainingModules[
        this.selectedTrainingModuleContent.trainingModuleIndex
      ]?.trainingModuleContents[
        this.selectedTrainingModuleContent.trainingModuleContentIndex
      ];
    },
  },
  methods: {
    emitUpdateTraining(updateObject) {
      const clonedTraining = { ...this.training };

      if (updateObject === "DELETE") {
        clonedTraining.deletedTrainingModuleContents = [
          ...(clonedTraining.deletedTrainingModuleContents ?? []),
          clonedTraining.trainingModules[
            this.selectedTrainingModuleContent.trainingModuleIndex
          ]?.trainingModuleContents[
            this.selectedTrainingModuleContent.trainingModuleContentIndex
          ]?._id,
        ];

        clonedTraining.trainingModules[
          this.selectedTrainingModuleContent.trainingModuleIndex
        ].trainingModuleContents.splice(
          this.selectedTrainingModuleContent.trainingModuleContentIndex,
          1
        );

        this.$emit("update:training", clonedTraining);
        this.$emit("update:selectedTrainingModuleContent", null);
      } else {
        clonedTraining.trainingModules[
          this.selectedTrainingModuleContent.trainingModuleIndex
        ].trainingModuleContents[
          this.selectedTrainingModuleContent.trainingModuleContentIndex
        ] = {
          ...this.trainingModuleContent,
          ...updateObject,
        };

        this.$emit("update:training", clonedTraining);
      }
    },
    updateTrainingModuleContentTitle(values) {
      this.emitUpdateTraining({
        title: values,
        hasChangesInTitle: true,
        hasInvalidTitle: !values?.find(x => x.value?.trim()?.length),
      });
    },
    updateTrainingModuleContentDuration(value) {
      value = this.getInteger(value);

      this.emitUpdateTraining({
        duration: value,
        hasChangesInDuration: true,
      });
    },
    updateTrainingModuleContentDescription(values) {
      this.emitUpdateTraining({
        description: values,
        hasChangesInDescription: true,
      });
    },
    updateTrainingModuleContentText(values) {
      this.emitUpdateTraining({
        text: values,
        hasChangesInText: true,
      });
    },
    deleteTrainingModuleContent() {
      if (this.isTrainingModuleContentDeleting) return;

      this.$dialog
        .confirm(
          this.$t("course.courseDetails.confirmTrainingModuleContentDelete")
        )
        .then(() => {
          this.emitUpdateTraining("DELETE");
        })
        .catch(_ => {});
    },
  },
};
</script>

<style lang="scss" scoped />
